import React from "react";
import LocationMap from "@/src/shared/components/LocationMap";
import type { IListing } from "@/src/shared/types/listing";

/** "Where you'll be": the app's rounded map card, with no address (it comes after booking). */
const ListingLocation: React.FC<{
  listing: Pick<IListing, "google_map_cache" | "location">;
}> = ({ listing }) => (
  <section>
    <h2 className="text-xl font-semibold text-ink md:text-22">
      Where you&apos;ll be
    </h2>
    <div className="mt-5 h-[294px] overflow-hidden rounded-xl bg-[#F7F7F7] md:h-[400px]">
      {listing.google_map_cache ? (
        <img
          src={listing.google_map_cache}
          alt="Map of the area"
          className="h-full w-full object-cover opacity-80"
        />
      ) : listing.location ? (
        <LocationMap height="100%" location={listing.location} />
      ) : null}
    </div>
    <p className="mt-3 text-sm font-medium text-ink-secondary">
      Exact location provided after booking
    </p>
  </section>
);

export default ListingLocation;
